"use client";

import useCommunityAndChannelParams from "@/hooks/useChannelAndCommunityParams";
import { useCommunityContext } from "@/providers/community-provider";
import Feed from "./components/feed/feed";
import FeedCreatePost from "./components/feed/feed-create-post";
import ExternalCommunityHero from "./components/hero-section/external-community-hero-section";
import PublicFeedHero from "./components/hero-section/public-feed-hero-section";
import RightSidebar from "./components/right-sidebar";
import { useModeratorContext } from "@/providers/moderator-provider";
import CommunityYoutubeBanner from "./components/hero-section/community-banner-youtube";

const Community = () => {
	const { communityInfo } = useCommunityContext();
	const { communitySlug, channelSlug, isPublicFeed } = useCommunityAndChannelParams();

	const { communities } = useModeratorContext();
	const isCommunityModerator = !!communities?.find((community) => community.slug === communitySlug);
	if (!communityInfo) {
		return null;
	}

	return (
		<>
			{isPublicFeed ? (
				<PublicFeedHero communityInfo={communityInfo} />
			) : communityInfo.slug === "africa-valuation-conference" ||
			  communityInfo.slug === "women-in-proptech" ||
			  communityInfo.slug === "proptech-india" ||
			  communityInfo.slug === "proptech-austria" ||
			  communityInfo.slug === "portugal-rei-club" ||
			  communityInfo.slug === "proptech-germany" ||
			  communityInfo.slug === "global-proptech-founders" ||
			  communityInfo.slug === "proptech-bangladesh" ||
			  communityInfo.slug === "bim-digital-twin" ||
				communityInfo.slug === "latam" ? (
				<CommunityYoutubeBanner communityInfo={communityInfo} />
			) : (
				<ExternalCommunityHero communityInfo={communityInfo} />
			)}

			<div className="flex items-start justify-center gap-2 max-md:flex-wrap">
				<div className="w-full flex-1 space-y-4 overflow-hidden">
					<FeedCreatePost />

					<Feed
						isPublicFeed={isPublicFeed}
						communitySlug={communitySlug}
						channelSlug={channelSlug}
						isCommunityModerator={isCommunityModerator}
					/>
				</div>

				<RightSidebar />
			</div>
		</>
	);
};

export default Community;
